import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../config/app-settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private formHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  /**
   * Reenviar email de verificación (público, sin autenticación)
   * POST /api/email/resend-verification
   */
  resendVerification(email: string): Observable<any> {
    return this.http.post<any>(
      AppSettings.API_URI + '/email/resend-verification',
      { email },
      this.formHeaders
    );
  }

  /**
   * Enviar notificación de verificación (autenticado)
   * POST /api/email/verification-notification
   */
  sendVerificationNotification(): Observable<any> {
    return this.http.post<any>(
      AppSettings.API_URI + '/email/verification-notification',
      {},
      this.formHeaders
    );
  }

  /**
   * Verificar email por ID y hash
   * GET /api/email/verify/{id}/{hash}
   */
  verifyEmail(id: string, hash: string): Observable<any> {
    return this.http.get<any>(
      AppSettings.API_URI + `/email/verify/${id}/${hash}`,
      this.formHeaders
    );
  }

  /**
   * Consultar estado de verificación (autenticado)
   * GET /api/email/verify-status
   */
  getVerificationStatus(): Observable<any> {
    return this.http.get<any>(
      AppSettings.API_URI + '/email/verify-status',
      this.formHeaders
    );
  }
}
